export const belaboxOverlayLabels = (language: "de" | "en") => language === "de"
  ? {
    editorLabel: "BELABOX-Status",
    editorAddLabel: "BELABOX-Status hinzufügen",
    editorDescription: "Zeigt Verbindung, Bitrate und Laufzeit des BELABOX-Relays.",
    editorModuleLabel: "BELABOX",
    noData: "keine Daten",
    healthy: "stabil",
    low: "Bitrate niedrig",
    disconnected: "Verbindung weg",
    inactive: "inaktiv",
    layout: "Darstellung",
    compact: "Kompakt",
    detail: "Mit RTT",
    unit: "Bitrate-Einheit",
    kbps: "kbps",
    mbps: "Mbit/s",
    hideWhenHealthy: "Ausblenden, wenn stabil oder inaktiv",
    onDemandNotice: "Im Modus „Bei Bedarf“ wird dieses Element nicht live aktualisiert.",
  }
  : {
    editorLabel: "BELABOX status",
    editorAddLabel: "Add BELABOX status",
    editorDescription: "Shows the BELABOX relay connection, bitrate, and uptime.",
    editorModuleLabel: "BELABOX",
    noData: "no data",
    healthy: "healthy",
    low: "low bitrate",
    disconnected: "disconnected",
    inactive: "inactive",
    layout: "Layout",
    compact: "Compact",
    detail: "With RTT",
    unit: "Bitrate unit",
    kbps: "kbps",
    mbps: "Mbps",
    hideWhenHealthy: "Hide when healthy or inactive",
    onDemandNotice: "In on-demand mode, this element does not update live.",
  };
